import { Outlet } from "@tanstack/react-router";

export function StandaloneLayout() {
  return (
    <div className="min-h-screen bg-bg-primary p-4">
      <Outlet />
    </div>
  );
}
